export const getValueFromGlobalOptions = (globalOptions, key) => {
  if (Array.isArray(globalOptions)) {
    let obj = globalOptions.find((x) => x.go_key === key);

    if (obj) {
      return obj['go_value'];
    }
  }

  return null;
};

export const getNumberFormatter = (format, precision = 2) => {
  return (number) => {
    if (number !== null && number !== undefined && !isNaN(number)) {
      return Number(number).toLocaleString(format, {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
      });
    } else {
      return (0).toLocaleString(format, {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
      });
    }
  };
};

export const currFormat = getNumberFormatter('en-US', 2);
